import { useTranslation } from '@shared/core';
import { useMemo } from 'react';
import { CardPaperType } from '../routes/CardCustomizer/CardCustomizer.types';

interface PaperDetails {
  label: string;
  description: string;
  weight: string;
  thickness?: string;
  imageUrl: string;
}

export function usePaperTypes(): Partial<Record<CardPaperType, PaperDetails>> {
  const { tq } = useTranslation('stationery');

  return useMemo(
    () => ({
      [CardPaperType.signature]: {
        label: tq`Signature`,
        description: tq`Our luxurious signature card stock has a velvety cotton texture and elegant eggshell finish.`,
        weight: tq`120lb. / 324gsm`,
        imageUrl: 'https://withjoy.com/media/paper-type/signature.jpg',
      },
      [CardPaperType.smooth]: {
        label: tq`Smooth`,
        description: tq`Similar in feel to our signature stock, but with a smooth, matte finish. Recommended for photo cards.`,
        weight: tq`120lb. / 324gsm`,
        imageUrl: 'https://withjoy.com/media/paper-type/signature.jpg',
      },
      [CardPaperType.semiGloss]: {
        label: tq`Semi-Gloss`,
        description: tq`Bright white with a semi-gloss finish. Recommended for photo cards.`,
        weight: tq`130lb. / 352gsm`,
        imageUrl: 'https://withjoy.com/media/paper-type/signature.jpg',
      },
      [CardPaperType.pearlescent]: {
        label: tq`Pearlescent`,
        description: tq`Add an elegant iridescence to printed cards and a soft glow to photographs with Pearlescent paper.`,
        weight: tq`110lb. / 300gsm`,
        imageUrl: 'https://withjoy.com/media/paper-type/pearlescent.jpg',
      },
      [CardPaperType.doubleThick]: {
        label: tq`Double Thick`,
        description: tq`Twice as thick as our signature paper, with the same eggshell finish and velvety cotton texture.`,
        weight: tq`240lb. / 648gsm`,
        thickness: '30pt',
        imageUrl: 'https://withjoy.com/media/paper-type/double.jpg',
      },
      [CardPaperType.tripleThick]: {
        label: tq`Triple Thick`,
        description: tq`Extra thick and luxurious, with the same eggshell finish and cottony texture as our signature paper.`,
        weight: tq`360lb. / 972gsm`,
        thickness: '60pt',
        imageUrl: 'https://withjoy.com/media/paper-type/triple.jpg',
      },
    }),
    [tq],
  );
}
